var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getPlatformType, PlatformType, getSystemType, SystemType } from '@nibfe/mkt-env-api';
import { getRiskParams } from '@nibfe/mkt-risk-api';
export const getMtProgramRiskParams = (queryParams = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const { utm_medium = '', uuid: openIdFromQuery, openIdCipher = '' } = queryParams !== null && queryParams !== void 0 ? queryParams : {};
    let riskResult;
    try {
        riskResult = yield getRiskParams(2);
    }
    catch (e) {
        // ignore
        console.error('静态货架获取风控参数失败', e);
        return {
            openId: openIdFromQuery,
            utm_medium,
            openIdCipher: openIdCipher,
            programName: 'mt',
            antiRepPlatform: getSystemType() === SystemType.ios ? 'IOS' : 'Android'
        };
    }
    const platformType = getPlatformType();
    if (platformType === PlatformType.mtMinaWebview) {
        return {
            openId: riskResult.openid || openIdFromQuery,
            utm_medium,
            openIdCipher: openIdCipher,
            programName: 'mt',
            antiRepPlatform: getSystemType() === SystemType.ios ? 'IOS' : 'Android'
        };
    }
    return {};
});
